<template>
    <div>
        <div v-show="isFirstTime" class="text-center">

            <div class="login-line-wrapper">

                <div class="text-chanel img-fluid"><img src="../../../assets/icon/white@3x.png"></div>
            </div>
            <div class="btn btn-continue" @click="clickLoginLine()">ดำเนินการต่อ</div>
            <!-- <div>
                <button @click="clickLoginLine()">Click Login Line</button>
            </div> -->
            <!-- กำลัง Login Line

            <br/>

            {{error}} -->
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import Account from "../../../helper/AccountHelper.js";
import LineFunction from "@/helper/facade/LineFunction.js";
import BzbsAuth from "@/service/BzbsAuth";
import CacheHelper from "@/helper/CacheHelper.js";
import Util from "@/helper/Utility.js"
import moment from "moment";

export default {
    name: "LoginLine",
    data: function() {
        return {
            liffId: Vue.bzbsConfig.liffId,
            error: null,
            initSuccess: false,
            loop: 0,
            count: 0,
            isFirstTime: false,
            remarkParam: '',
            isSavelog: false,
        };
    },
    created: function() {


        this.initial();

    },
    methods: {
        initial: async function () {
            if (this.checkMaintenance()) {
                return
            }
            this.setupCache();

            var cacheHelper = new CacheHelper('cookie');
            this.isFirstTime = cacheHelper.getCache('isFirstTime');
            this.isSavelog = cacheHelper.getCache('isSavelog');

            if (!this.isSavelog) {

                var str = window.location.href;
                var n = str.indexOf("liffClientId");
                if (n > 1) {
                    return;
                }
                await this.callApiFreelog();
            }

            if (!this.isFirstTime) {
                this.initLiff();
            }
        },

        clickLoginLine: function() {
            this.count += 1;
            if (this.count < 5) {
                this.initLiff();
            } else {
                window.location.reload();
            }

        },

        // getLiffId: function() {
        //     this.liffId = Vue.bzbsConfig.liffId;
        //     //var url = window.location.href;
        //     // var urlPointPrd = Vue.bzbsConfig.urlPoingPrd;

        //     // if (url.search(urlPointPrd) >= 0) {
        //     //     this.liffId = Vue.bzbsConfig.liffIdPointPrd;
        //     // }
        // },
        initLiff: function() {
            var lineFunction = new LineFunction();

            this.liffId = lineFunction.getLiffId();
            lineFunction.init(this.liffId).then(() => {
                //var currentUrl = window.location.href;
                var currentUrl= window.location.protocol + "//" + window.location.host + window.location.pathname;
                console.log(currentUrl)

                var cacheHelper = new CacheHelper('cookie');

                if (lineFunction.isLogin()) {

                    if (lineFunction.isTokenExpire()) {
                        lineFunction.logout();
                        lineFunction.login(currentUrl);
                        return;
                    }

                    var idToken = lineFunction.getIdToken();

                    try {

                        cacheHelper.setCache('idLineToken', idToken);
                    }
                    catch(ex){
                        // alert(ex);
                    }

                    if (idToken != null) {
                        // alert(this.$route.query.boutiqueId);
                        // alert(this.$route.query.sourceId);
                        // alert(this.$route.query.campaignid);
                        // alert(this.$route.query.tag);

                        // this.isFirstTime = cacheHelper.setCache('isFirstTime', true);
                        cacheHelper.removeCache('isFirstTime');
                        cacheHelper.removeCache('isSavelog');
                        this.initSuccess = true;
                        this.loginBzbs(idToken);
                    } else {
                        this.isFirstTime = cacheHelper.setCache('isFirstTime', true);
                         window.location.replace('/errorPage');

                    }
                } else {

                    this.isSavelog = cacheHelper.setCache('isSavelog', true);

                    setTimeout(() => {
                        lineFunction.login(currentUrl);
                    }, 500);
                }
            }).catch((err) => {

                var date = moment(new Date()).format('YYYY-DD-MMTHH:MM:SS');
                var osname = Util.getOSName();
                var ua = navigator.userAgent;
                var lineVersion = Vue.bzbsConfig.lineVersion;

                BzbsAuth.apiErrorLog(err, date, osname, lineVersion, ua, this.remarkParam).then((res) => {

                    console.log(res);
                    var cacheHelper = new CacheHelper('cookie');
                    this.isFirstTime = cacheHelper.setCache('isFirstTime', true);
                    window.location.replace('/errorPage');

                }).catch((err) => {

                    // window.location.replace('/errorPage');
                    console.log(err);
                });

            });
        },
        loginBzbs: async function(idToken) {

            await this.apiLoginLine(idToken);
            await this.apiGetProfile();
            //this.redirectLogin();
            // if (user.userLevel <= 0) {
            //     this.redirectNotLogin();
            // } else {
            //     this.redirectLogin();
            // }
            // BzbsAuth.apiLoginLine(idToken).then((res) => {
            //     //userLevel = res.data.userLevel;

            //     cacheHelper.setCache('test', res.data);
            //     Account.setLogin(res.data);
            //     this.redirectLogin();
            //     return Account.apiGetProfile();
            // }).catch((err) => {

            //     console.log(err.response.data);
            //     window.location.href = '/register';
            // });
        },
        apiLoginLine: async function(idToken) {
            var userLevel = 0;
            BzbsAuth.apiLoginLine(idToken).then((res) => {
                userLevel = res.data.userLevel;
                Account.setLogin(res.data);
                return Account.apiGetProfile();
            }).then(() => {
                if (userLevel <= 0) {
                    this.redirectNotLogin();
                } else {
                    this.redirectLogin();
                }
            }).catch((err) => {
                console.log(err.response.data);
                // TODO remove this debug
                alert(err.response.data);
                window.location.replace('/errorPage');
                // window.location.replace('/register');
            });
        },
        apiGetProfile: async function() {
            return new Promise((resolve, reject) => {
                Account.apiGetProfile().then(() => {
                    resolve();
                }).catch((err) => {
                    // this.$router.push('/register');
                    window.location.replace('/register');
                    reject(err);
                });
            })
        },

        redirectNotLogin: function() {
            var targetPage = this.$route.query.target_page;
            switch (targetPage) {
                case 'register':
                    window.location.replace('/register');
                    // this.$router.push('/register');
                    break;
                default:
                    window.location.replace('/register');
                    // this.$router.push('/');
                    // window.location.href = '/';
            }
        },
        redirectLogin: function() {
            var targetPage = this.$route.query.target_page;
            // var campaignId = this.$route.query.campaignid;
            switch (targetPage) {
                case "register":
                    window.location.replace('/unregister');
                    // this.$router.push('/collectpoint');
                    break;
                // case "campaign":
                //     if (campaignId != "" && campaignId != null)
                //     {
                //         window.location.replace("/detail/" + campaignId);
                //     } else {
                //         window.location.replace('/unregister');
                //     }
                //     // this.$router.push('/privilege');
                //     break;
                default:
                    window.location.replace('/unregister');
                    // this.$router.push('/');
            }
        },
        callApiFreelog: function () {

            return new Promise((resolve) => {

                var date = new Date();
                var cacheHelper = new CacheHelper('cookie');
                // var unixTime = (date.getTime() - date.getTimezoneOffset() * 60 * 1000) / 1000;
                // var strDate = moment.unix(unixTime).utc().format('YYYY-MM-DDTHH:mm:ss');

                var bid = "";
                if (this.$route.query.boutiqueId) {

                    bid = this.$route.query.boutiqueId;

                } else if (this.$route.query.boutiqueid) {

                    bid = this.$route.query.boutiqueid;

                } else {
                    bid = "NONE";
                    var fromSystm = cacheHelper.getCache('fromsystem', true);
                    if (fromSystm) {
                        bid = "SYSTEM";
                    }
                }

                var param = {
                    date: date,
                    BU: 'CHF',
                    Full: window.location.href,
                    STEP: 'Page loaded',
                    appId: Vue.bzbsConfig.client_id,
                    boutiqueId: bid,
                }
                BzbsAuth.apiFreeLog(param).then((res) => {

                        console.log(res);

                        var cacheLocal = new CacheHelper('local');
                        cacheLocal.setCache('refKey', res.data.refKey);



                        cacheHelper.removeCache('fromsystem');

                        resolve();

                    }).catch((err) => {
                        resolve();
                        // window.location.replace('/errorPage');
                        console.log(err);
                    });
            })

        },
        setupCache: function () {
            var cache = new CacheHelper('cookie');

            var cacheLocal = new CacheHelper('local');

            if (this.$route.query.target_page) {

                cache.setCache('target_page', this.$route.query.target_page);

                this.remarkParam =  this.remarkParam + "target_page:" +  cache.getCache('target_page');
                //this.remarkParam =  this.remarkParam + "target_page:" + this.$route.query.target_page+"/";
            }
            if (this.$route.query.boutiqueId) {

                cache.setCache('boutiqueId',  this.$route.query.boutiqueId);
                cacheLocal.setCache('boutiqueId', this.$route.query.boutiqueId);

                // this.remarkParam =  this.remarkParam + "boutiqueId:" + this.$route.query.boutiqueId+"/";
                this.remarkParam =  this.remarkParam + "boutiqueId:" +  cache.getCache('boutiqueId');
            }
            if (this.$route.query.boutiqueid) {

                cache.setCache('boutiqueId', this.$route.query.boutiqueid);
                cacheLocal.setCache('boutiqueId', this.$route.query.boutiqueid);
                // this.remarkParam =  this.remarkParam + "boutiqueId:" + this.$route.query.boutiqueId+"/";
                this.remarkParam =  this.remarkParam + "boutiqueId:" +  cache.getCache('boutiqueId');
            }
            if (this.$route.query.sourceId) {

                cache.setCache('sourceId', this.$route.query.sourceId);

                this.remarkParam =  this.remarkParam + "sourceId:" +  cache.getCache('sourceId');
                // this.remarkParam =  this.remarkParam + "sourceId:" + this.$route.query.sourceId+"/";
            }
            if (this.$route.query.tag) {

                cache.setCache('tag', this.$route.query.tag);

                this.remarkParam =  this.remarkParam + "tag:" +  cache.getCache('tag');
                // this.remarkParam =  this.remarkParam + "tag:" + this.$route.query.tag+"/";
            }
        },
        checkMaintenance: function () {
            console.log("checkMaintenance")
            let StartDateMaintenance = window.StartDateMaintenance;
            let EndDateMaintenance = window.EndDateMaintenance;

            // StartDateMaintenance = "2024-02-19 15:00:00"
            // EndDateMaintenance = "2024-02-19 15:08:00"
            if (Util.isEmptyStr(StartDateMaintenance) || Util.isEmptyStr(EndDateMaintenance)) {

                console.log("checkMaintenance ISEMPTY")
                return false;
            } else {
                var stDate = new Date(StartDateMaintenance)
                var edDate = new Date(EndDateMaintenance)
                var today = new Date()
                if ( today > stDate && today < edDate)
                {
                    window.location.replace('/maintenance');
                    return true;
                }
                return false;
            }

        }
    },
}
</script>
<style lang="scss" scoped>
    .login-line-wrapper {
        background-color: white;
        border-top: 3px solid black;
        min-height: 100vh;
        display: flex;
        .text-chanel {
            margin: auto;
            img {

                width: 150px;
            }
        }

    }
    .btn-continue {
        background-color: #000;
        border: 2px solid #000;
        margin: auto auto 20px auto;
        color: white;
        width: 80%;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
    }
</style>
